import { useMediaStore as useMediaStorePinia } from '../stores/MediaStore'

export const useMediaStore = () => {
    return useMediaStorePinia()
}
